import axios from "api";

const POLL_INTERVAL_MS = 2000;
const MAX_ATTEMPTS = 10;

export type SubscriptionPaymentPollType = "vendor" | "customer";

export async function waitForSubscriptionPaymentStatus(
  orderId: string,
  type: SubscriptionPaymentPollType
): Promise<{ activated: boolean; status: string | null }> {
  let lastStatus: string | null = null;
  for (let attempt = 0; attempt < MAX_ATTEMPTS; attempt++) {
    try {
      const { data } = await axios.get<{ status: string | null; activated: boolean }>(
        "/subscription/status",
        { params: { order_id: orderId, type } }
      );
      lastStatus = data.status != null ? String(data.status) : null;

      if (data.activated) {
        console.log("[PAYMENT_DEBUG] poll: activated=true, stop", { orderId });
        return { activated: true, status: lastStatus };
      }
    } catch (e: unknown) {
    }
    if (attempt < MAX_ATTEMPTS - 1) {
      await new Promise((resolve) => setTimeout(resolve, POLL_INTERVAL_MS));
    }
  }
  return { activated: false, status: lastStatus };
}

export const SUBSCRIPTION_PAYMENT_PENDING_MESSAGE =
  "Payment received. Your subscription is being activated, please wait a moment.";
